import { render } from "./MoveVod.vue?vue&type=template&id=65ad38d6"
import script from "./MoveVod.vue?vue&type=script&setup=true&lang=js"
export * from "./MoveVod.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/VOD/MoveVod.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "65ad38d6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('65ad38d6', __exports__)) {
    api.reload('65ad38d6', __exports__)
  }
  
  module.hot.accept("./MoveVod.vue?vue&type=template&id=65ad38d6", () => {
    api.rerender('65ad38d6', render)
  })

}


export default __exports__